import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { PrimaryButon } from "../../../../../components/common/button/PrimaryButon";
import { rowCenter } from "../../../../../style/style";
import { palette } from "../../../../../../theme/palette";
import dayjs from "dayjs";
import { useAppDispatch } from "@application/store/useStore";
import { updateAssignmentContractEndDateAsync } from "@application/features/assignments/assignmentThunk";
const theme = palette("light");
export const ContractEndDateExtendConfirmationDialog = ({ open, handleClose, selectedRow }) => {
    const deadlineDate = dayjs().add(1, 'day').set('hour', 23).set('minute', 59).set('second', 59);
    const formattedDeadline = deadlineDate.format('DD-MM-YYYY HH:mm:ss');
    const dispatch = useAppDispatch();
    const handleSubmit = () => {
        dispatch(updateAssignmentContractEndDateAsync({
            assignmentId: selectedRow.assignmentId,
        }))
            .unwrap()
            .then(() => {
            handleClose();
        })
            .catch((error) => {
        });
    };
    return (_jsx(Dialog, { open: open, onClose: handleClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: "blur(3px)",
                backgroundColor: "rgba(74, 74, 74, 0.25)",
            },
        }, children: _jsxs(Box, { width: 717, sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                position: "relative",
                height: "295px",
            }, children: [_jsx(Typography, { variant: "h3", color: "initial", mt: 2, children: "Extend Contract End Date" }), _jsxs(Typography, { variant: "subtitle1", color: theme.black.dark, children: ["Are you sure you want to extend contract end date by ", formattedDeadline, " ?"] }), _jsxs(Box, { sx: { ...rowCenter, gap: 2, width: "400px" }, mt: 3, children: [_jsx(Box, { width: 223, children: _jsx(PrimaryButon, { onClick: handleClose, children: "Close" }) }), _jsx(Button, { variant: "text", color: "secondary", onClick: handleSubmit, children: "Yes" })] })] }) }));
};
